export default {
  title: '{{company}} actualizó tu hora de recogida',
  new_time_label: 'Nueva hora',
};
